import styled, { css } from 'styled-components'

import { Link } from '@subaio/components'

import { helpers } from 'styles'

type Props = {
	fullWidth?: boolean
	link?: boolean
	slim?: boolean
	type?: keyof Omit<typeof helpers.color, 'status' | 'input' | 'button'>
}

export const inlineStyling = css<Props>`
	display: inline;
	color: ${({ type = 'primary', theme }) => theme.color[type]};
	background-color: transparent;
	width: ${({ fullWidth }) => fullWidth && '100%'};
	height: ${({ slim }) => (slim ? '34px' : '40px')};
	transition: color 0.2s, background-color 0.2s;
	white-space: nowrap;
	text-align: center;

	&:is(:focus-visible, :hover) {
		color: ${({ type = 'primary', theme }) => theme.color[type]};
		text-decoration: none;
	}

	&:focus-visible {
		outline: 2px solid ${helpers.color.link};
		outline-offset: -2px;
	}

	&:disabled {
		color: ${helpers.color.disabled};
		background-color: transparent;
	}
`

export const Inline = styled(Link)<Props>`
	${inlineStyling};
`
